<ng-template #prefferedAgent>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div
                style="width: 814px; max-width: 814px; width: 100%; height: auto; margin: 0 auto; padding: 20px 44px 40px; background: #fff">
                <div *ngIf="this.currentAgent && !this.changeAgent">
                    <cpc-preferred-agent [(isVisiblePopup)]="isVisiblePopup" [prefferedAgent]="currentAgent"
                        [agentDetailsText]="getAgentDetailsText()" [setButtonText]="setButtonText"
                        [editButtonText]="getChangeButtonText()" (selectedAgent)="selectedAgent($event)"
                        (editAgent)="editAgent($event)" [title]="'preffered-agent.not-set.title' | translate"></cpc-preferred-agent>
                </div>
                <div *ngIf="!this.currentAgent || this.changeAgent">
                    <cpc-change-agent [headTitle]="'preffered-agent.not-set.title' | translate " [title]="getText()"
                        [agents]="agents" [currentAgent]="currentAgent" [submitButtonText]="getSubmitBtnText()"
                        (isVisiblePopupChange)="changePopup($event)" (setAgent)="setAgent($event)"
                        [isVisiblePopup]="isVisiblePopup"></cpc-change-agent>
                </div>
            </div>
        </div>
    </div>
</ng-template>